/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * ows-abacus-state
 * OpenAPI spec version: 1.0.0
 */

/**
 * Name of the parent table
 */
export type ParentTableName =
  (typeof ParentTableName)[keyof typeof ParentTableName];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ParentTableName = {
  account_payee: "account_payee",
  accounting_period: "accounting_period",
  accounting_run: "accounting_run",
  contract: "contract",
  payee: "payee",
  payment_group_payment: "payment_group_payment",
  payment_group_payment_account: "payment_group_payment_account",
  payment_group_payment_batch: "payment_group_payment_batch",
  sales_file: "sales_file",
  statement_period: "statement_period",
  statement_period_adjustment_file: "statement_period_adjustment_file",
  statement_period_payment_entity: "statement_period_payment_entity",
  worksheet_payment_contract_advance: "worksheet_payment_contract_advance",
} as const;
